import { useQuery } from '@tanstack/react-query';
import { get } from '../api/api';
import { API_URLS } from '../constants/apiUrl';
import { QueryParamObject, toQueryString } from '../constants/utilityFunctions';
import { IConflictCheck } from '../interface/conflictCheck';
import { Entities } from '../interface/common';

interface IFetchConflictChecksById {
  id?: string;
  relations?: string[];
  fields?: string[];
}
export const useFetchConflictChecksById = (params: IFetchConflictChecksById) => {
  const { id, ...queryParams } = params;
  const queryString = Object.keys(queryParams)?.length
    ? toQueryString(queryParams as QueryParamObject)
    : null;
  const conflictCheckUrl = `${API_URLS.CREATE_CONFLICT_CHECK}/${id}`;
  const url = queryString ? `${conflictCheckUrl}?${queryString}` : conflictCheckUrl;
  const query = useQuery<IConflictCheck, Error>({
    queryKey: ['conflict-check-details', id],
    queryFn: async () => {
      const response = await get(
        url,
        {},
        {
          headers: {
            entity: Entities.CONFLICTCHECKS,
          },
        },
      );
      return response;
    },
    enabled: !!id,
  });

  return query;
};
